var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-header"},[_c('div',{staticClass:"icon-container",staticStyle:{"margin":"14px 0 4px 6px"}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left","size":"lg"},on:{"click":_vm.goBack}})],1),_c('div',{staticClass:"background"}),_c('MobileMenu',{attrs:{"is-mobile":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }